var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 268,
    viewBox: "0 0 520 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4185 4H519.5V1H2.5H1V2.5V267.419H4V25.3857L19.4185 4Z",
    fill: "#4083E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4185 4L19.1122 3.77911L19.2252 3.6223H19.4185V4ZM519.5 4H519.878V4.3777H519.5V4ZM519.5 1V0.622302H519.878V1H519.5ZM1 1H0.622314V0.622302H1V1ZM1 267.419V267.797H0.622314V267.419H1ZM4 267.419H4.37769V267.797H4V267.419ZM4 25.3857H3.62231V25.2638L3.6936 25.1648L4 25.3857ZM19.4185 3.6223H519.5V4.3777H19.4185V3.6223ZM519.122 4V1H519.878V4H519.122ZM519.5 1.3777H2.5V0.622302H519.5V1.3777ZM2.5 1.3777H1V0.622302H2.5V1.3777ZM1.37769 1V2.5H0.622314V1H1.37769ZM1.37769 2.5V267.419H0.622314V2.5H1.37769ZM1 267.042H4V267.797H1V267.042ZM3.62231 267.419V25.3857H4.37769V267.419H3.62231ZM3.6936 25.1648L19.1122 3.77911L19.7249 4.22089L4.3064 25.6066L3.6936 25.1648Z",
    fill: "#4083E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineL);
export default __webpack_public_path__ + "static/media/line_l.98cdd57683066304aa705298eb747365.svg";
export { ForwardRef as ReactComponent };